import React, { useState } from "react";
import { ArrowUpRight, Search, Filter, MoreVertical } from "lucide-react";

const TopTransactionHistory = (topTickets) => {
  console.log(topTickets);
  const [searchQuery, setSearchQuery] = useState("");

  const transactions = topTickets.topTicketing
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "paid":
        return "bg-success";
      case "due":
        return "bg-warning";
      case "cancel":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };
  return (
    <div className="container p-0">
      <div className="card shadow-lg" style={{borderRadius:"15px"}}>
        <div className="" style={{borderRadius:"15px"}}>
          <h5 className="card-title fs-5 mt-1 mb-0 me-2 p-4 pb-2">Top Ticketing</h5>
          {
             <div
              className="list-group-item d-flex justify-content-between align-items-center"
              style={{border:"0px solid black", paddingTop:"0px", paddingBottom:"0px"}}
           >
             <div className="d-flex">
             <div className="d-flex align-items-center me-3 mb-2">
               <div className="position-relative">
                 
                 <h6 className="mb-0">Category</h6>
                 <small className="text-muted mb-1">Subject</small>
                
               </div>
             </div>
             <div className="flex-1 d-none">
               <h6 className="mb-0">34</h6>
               <small className="text-muted">78</small>
             </div>
             </div>

             <div className="text-end d-flex flex-1 flex-row gap-2">
               <p
                 className="text-dark d-flex align-items-center justify-content-center"
                 style={{
                   borderRadius: "50%",
                   width: "30px",
                   height: "30px",
                   backgroundColor: "#cbeceff5",
                 }}
               >
                O
               </p>
               <p
                 className=" text-light d-flex align-items-center justify-content-center"
                 style={{
                   borderRadius: "50%",
                   width: "30px",
                   height: "30px",
                   backgroundColor: "#495a69",
                 }}
               >
                 C
               </p>
             </div>
           </div>
          }
        </div>
        {/* Transactions */}
        <ul className="list-group list-group-flush"  style={{height:"360px", overflowY:"auto"}}>
        
          {transactions.map((transaction) => (
            <li
              key={transaction.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div className="d-flex">
              {/* <div className="d-flex align-items-center me-3">
                <div className="position-relative">
                  <div class="MuiAvatar-root MuiAvatar-circular MuiAvatar-colorDefault css-oxhcte-MuiAvatar-root">
                    {" "}
                    {transaction.total_count}
                  </div>
                </div>
              </div> */}
              <div className="flex-1">
                <h6 className="mb-0">{transaction.category}</h6>
                <small className="text-muted">{transaction.subject}</small>
              </div>
              </div>

              <div className="text-end d-flex flex-1 flex-row gap-2">
                <p
                  className="text-dark d-flex align-items-center justify-content-center"
                  style={{
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    backgroundColor: "#cbeceff5",
                  }}
                >
                  {transaction.open_count}
                </p>
                <p
                  className=" text-light d-flex align-items-center justify-content-center"
                  style={{
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    backgroundColor: "#495a69",
                  }}
                >
                  {transaction.closed_count}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TopTransactionHistory;
